import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=4dd4fc1e&scoped=true&"
import script from "./ProductsTable.js?vue&type=script&lang=ts&"
export * from "./ProductsTable.js?vue&type=script&lang=ts&"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=4dd4fc1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd4fc1e",
  null
  
)

export default component.exports